import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { CookieAndTermType } from './cookiesAndTermsSlice'
import type { RootState } from '.'

export enum PopupType {
  COOKIES = 'cookies',
  OUTREACH = 'outreach',
  CHAIN_ALERTS = 'chainAlerts',
}

type PopupState = {
  [PopupType.COOKIES]: {
    open: boolean
    warningKey?: CookieAndTermType
  }
  [PopupType.OUTREACH]: {
    open: boolean
  }
  [PopupType.CHAIN_ALERTS]: {
    open: boolean
    forced: boolean
  }
}

const initialState: PopupState = {
  [PopupType.COOKIES]: {
    open: false,
  },
  [PopupType.OUTREACH]: {
    open: false,
  },
  [PopupType.CHAIN_ALERTS]: {
    open: false,
    forced: false,
  },
}

export const popupSlice = createSlice({
  name: 'popups',
  initialState,
  reducers: {
    openCookieBanner: (state, { payload }: PayloadAction<{ warningKey?: CookieAndTermType }>) => {
      state[PopupType.COOKIES] = {
        ...payload,
        open: true,
      }
    },
    closeCookieBanner: (state) => {
      state[PopupType.COOKIES] = { open: false }
    },
    openOutreachBanner: (state) => {
      state[PopupType.OUTREACH] = { open: true }
    },
    closeOutreachBanner: (state) => {
      state[PopupType.OUTREACH] = { open: false }
    },
    openChainAlertsBanner: (state, { payload }: PayloadAction<{ forced?: boolean }>) => {
      state[PopupType.CHAIN_ALERTS] = {
        open: true,
        forced: payload?.forced ?? false,
      }
    },
    closeChainAlertsBanner: (state) => {
      state[PopupType.CHAIN_ALERTS] = {
        open: false,
        forced: false,
      }
    },
  },
})

export const {
  openCookieBanner,
  closeCookieBanner,
  openOutreachBanner,
  closeOutreachBanner,
  openChainAlertsBanner,
  closeChainAlertsBanner,
} = popupSlice.actions

export const selectCookieBanner = (state: RootState) => state[popupSlice.name][PopupType.COOKIES]
export const selectOutreachBanner = (state: RootState) => state[popupSlice.name][PopupType.OUTREACH]
export const selectChainAlertsBanner = (state: RootState) => state[popupSlice.name][PopupType.CHAIN_ALERTS]
